import { DEV, DEVELOPMENT, PROD, PRODUCTION, QA, FORCE_EVALUATIONS_HEADER, REASON_FORCED, REASON_RULE_MATCH, REASON_TARGET_MATCH, X_END_USER_ANONYMOUS_ID, X_END_USER_COUNTRY, X_END_USER_LOCALE, X_CLIENT_ID } from '@shutterstock/experiments-constants';
import { parse } from 'cookie';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _ENV_TO_HOST_MAP;
var ENV_TO_HOST_MAP = (_ENV_TO_HOST_MAP = {}, _ENV_TO_HOST_MAP[DEV] = '.dev', _ENV_TO_HOST_MAP[DEVELOPMENT] = '.dev', _ENV_TO_HOST_MAP[PROD] = '', _ENV_TO_HOST_MAP[PRODUCTION] = '', _ENV_TO_HOST_MAP[QA] = '.qa', _ENV_TO_HOST_MAP);

var ACCEPT = 'Accept';
var AUTHORIZATION = 'Authorization';

var DEFAULT_TIMEOUT = 2000;
var fetchWithTimeout = function fetchWithTimeout(_ref) {
  var url = _ref.url,
    options = _ref.options;
  try {
    var abortController = new AbortController();
    var id = setTimeout(function () {
      return abortController.abort();
    }, options.timeout || DEFAULT_TIMEOUT);
    return Promise.resolve(fetch(url, {
      headers: options.headers || {},
      signal: abortController.signal
    })).then(function (response) {
      clearTimeout(id);
      return response;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }
        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }
    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }
    pact.s = state;
    pact.v = value;
    var observer = pact.o;
    if (observer) {
      observer(pact);
    }
  }
}
var _Pact = /*#__PURE__*/function () {
  function _Pact() {}
  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;
    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;
      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }
        return result;
      } else {
        return this;
      }
    }
    this.o = function (_this) {
      try {
        var value = _this.v;
        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };
    return result;
  };
  return _Pact;
}();
function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}
function _for(test, update, body) {
  var stage;
  for (;;) {
    var shouldContinue = test();
    if (_isSettledPact(shouldContinue)) {
      shouldContinue = shouldContinue.v;
    }
    if (!shouldContinue) {
      return result;
    }
    if (shouldContinue.then) {
      stage = 0;
      break;
    }
    var result = body();
    if (result && result.then) {
      if (_isSettledPact(result)) {
        result = result.s;
      } else {
        stage = 1;
        break;
      }
    }
    if (update) {
      var updateValue = update();
      if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
        stage = 2;
        break;
      }
    }
  }
  var pact = new _Pact();
  var reject = _settle.bind(null, pact, 2);
  (stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
  return pact;
  function _resumeAfterBody(value) {
    result = value;
    do {
      if (update) {
        updateValue = update();
        if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
          updateValue.then(_resumeAfterUpdate).then(void 0, reject);
          return;
        }
      }
      shouldContinue = test();
      if (!shouldContinue || _isSettledPact(shouldContinue) && !shouldContinue.v) {
        _settle(pact, 1, result);
        return;
      }
      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
        return;
      }
      result = body();
      if (_isSettledPact(result)) {
        result = result.v;
      }
    } while (!result || !result.then);
    result.then(_resumeAfterBody).then(void 0, reject);
  }
  function _resumeAfterTest(shouldContinue) {
    if (shouldContinue) {
      result = body();
      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
      } else {
        _resumeAfterBody(result);
      }
    } else {
      _settle(pact, 1, result);
    }
  }
  function _resumeAfterUpdate() {
    if (shouldContinue = test()) {
      if (shouldContinue.then) {
        shouldContinue.then(_resumeAfterTest).then(void 0, reject);
      } else {
        _resumeAfterTest(shouldContinue);
      }
    } else {
      _settle(pact, 1, result);
    }
  }
}
var ABORT_ERROR = 'AbortError';
var getRetryTimeoutErrorMsg = function getRetryTimeoutErrorMsg(numRetries, retryTimeout) {
  return "Timeout error failed " + numRetries + " numRetries at " + retryTimeout + " timeout each";
};
var fetchWithRetries = function fetchWithRetries(_ref) {
  var url = _ref.url,
    options = _ref.options,
    numRetries = _ref.numRetries;
  try {
    var _temp2 = function _temp2(_result2) {
      if (_exit) return _result2;
      throw Error(getRetryTimeoutErrorMsg(numRetries, retryTimeout));
    };
    var _exit;
    var numTried = 0;
    var retryTimeout = (options.timeout || DEFAULT_TIMEOUT) / numRetries;
    var fetchProps = {
      url: url,
      options: {
        headers: options.headers,
        timeout: retryTimeout
      }
    };
    var _temp = _for(function () {
      return !_exit && numTried < numRetries;
    }, void 0, function () {
      return _catch$1(function () {
        return Promise.resolve(fetchWithTimeout(fetchProps)).then(function (response) {
          _exit = 1;
          return response;
        });
      }, function (err) {
        if (err.name === ABORT_ERROR) {
          numTried += 1;
        } else {
          throw err;
        }
      });
    });
    return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
  } catch (e) {
    return Promise.reject(e);
  }
};

// If that header isn't present default to zero....
var getForcedVariation = function getForcedVariation(req) {
  var _req$headers, _req$cookies;
  if ((_req$headers = req.headers) != null && _req$headers[FORCE_EVALUATIONS_HEADER]) {
    var _req$headers2;
    return (req == null || (_req$headers2 = req.headers) == null ? void 0 : _req$headers2[FORCE_EVALUATIONS_HEADER]) + '';
  }
  // If sending application has already applied cookie parsing, use that value
  if (req != null && (_req$cookies = req.cookies) != null && _req$cookies[FORCE_EVALUATIONS_HEADER]) {
    var _req$cookies2;
    return (req == null || (_req$cookies2 = req.cookies) == null ? void 0 : _req$cookies2[FORCE_EVALUATIONS_HEADER]) + '';
  }
  var cookies = parse(req.headers.cookie || '');
  return cookies[FORCE_EVALUATIONS_HEADER] || '';
};

var getParamsFromURI = function getParamsFromURI(uri) {
  var _uri$split = uri.split('?'),
    paramString = _uri$split[1];
  return new URLSearchParams(paramString);
};
var QUERY_PARAM_EXPERIMENT_REG_EX = /^(experiment)\[(([a-z]|[A-Z]))*[0-9]*-[0-9]+.*]$/;
var getExperimentsFromQueryParam = function getExperimentsFromQueryParam(uri) {
  if (uri) {
    var allQueryParamEntriesArray = Array.from(getParamsFromURI(uri).entries());
    var experimentKeyIndexes = allQueryParamEntriesArray.reduce(function (acc, _ref, index) {
      var key = _ref[0];
      if (QUERY_PARAM_EXPERIMENT_REG_EX.test(key)) {
        return [].concat(acc, [index]);
      }
      return acc;
    }, []);
    if (experimentKeyIndexes.length === 0) return {};
    var queryParams = experimentKeyIndexes.reduce(function (acc, experimentKeyIndex) {
      var _allQueryParamEntries = allQueryParamEntriesArray[experimentKeyIndex],
        experimentQueryParamKey = _allQueryParamEntries[0],
        value = _allQueryParamEntries[1];
      if (typeof value === 'string') {
        var _extends2;
        var experimentKey = experimentQueryParamKey.slice(experimentQueryParamKey.indexOf('[') + 1, experimentQueryParamKey.indexOf(']'));
        return _extends({}, acc, (_extends2 = {}, _extends2[experimentKey] = {
          reason: REASON_FORCED,
          variationId: Number(value)
        }, _extends2));
      }
      return acc;
    }, {});
    return queryParams;
  }
  return {};
};
/**
 * A util for forcing ALL provided evaluations to control (0) or variant 1 (1)
 * An experiment is only guaranteed to have control and at least 1 variation.
 *
 * @param variation
 * @param evaluations
 * @returns
 */
var forceAllEvaluations = function forceAllEvaluations(variation, evaluations) {
  if (!evaluations) return {};
  if (!['0', '1'].includes(variation)) {
    return evaluations;
  }
  return Object.keys(evaluations).reduce(function (acc, id) {
    var _extends3;
    return _extends({}, acc, (_extends3 = {}, _extends3[id] = {
      reason: REASON_FORCED,
      variationId: Number(variation)
    }, _extends3));
  }, {});
};
var isExperimentsQueryParsed = function isExperimentsQueryParsed(query) {
  return typeof (query == null ? void 0 : query.experiment) === 'object';
};
var getQueryExperimentValue = function getQueryExperimentValue(_ref2) {
  var _query$experiment;
  var query = _ref2.query,
    experimentId = _ref2.experimentId;
  var queryVariant = isExperimentsQueryParsed(query) ? (_query$experiment = query.experiment) == null ? void 0 : _query$experiment[experimentId] : query == null ? void 0 : query["experiment[" + experimentId + "]"];
  if (typeof queryVariant === 'string') {
    var parsedVar = parseInt(queryVariant);
    if (!isNaN(parsedVar) && parsedVar >= 0) {
      return parsedVar;
    }
  }
  return undefined;
};
var SUPPORTED_REASONS = [REASON_RULE_MATCH, REASON_FORCED, REASON_TARGET_MATCH];
var getExperimentVariant = function getExperimentVariant(evaluations, experimentId) {
  if (evaluations === undefined) {
    return 0;
  }
  var _ref3 = evaluations[experimentId] || {},
    reason = _ref3.reason,
    variationId = _ref3.variationId;
  if (SUPPORTED_REASONS.includes(reason) && variationId !== undefined) {
    return variationId;
  }
  return 0;
};

/**
 * Override provided evaluations based on what's in the request object
 * @param req
 * @param evaluations
 * @returns
 */
var overrideEvaluations = function overrideEvaluations(req, evaluations) {
  // a request header can be a string or a string array. We only support this value as a string.
  var forcedVariation = req === undefined ? '' : getForcedVariation(req);
  var allEvaluations = forceAllEvaluations(forcedVariation, evaluations);
  var queryEvaluations = getExperimentsFromQueryParam(req == null ? void 0 : req.url);
  return _extends({}, allEvaluations, queryEvaluations);
};

// Do manual key check as JS usage could cause this not to be available
var getExperimentsHost = function getExperimentsHost(env) {
  if (!Object.keys(ENV_TO_HOST_MAP).includes(env)) {
    throw new Error("experiments-api-client getExperimentsHost Unsupported env passed: " + env);
  }
  var prefix = ENV_TO_HOST_MAP[env];
  return "https://experiments-service" + prefix + ".shuttercorp.net";
};
var fetchExperimentsService = function fetchExperimentsService(_ref) {
  var environment = _ref.environment,
    headers = _ref.headers,
    params = _ref.params,
    pathname = _ref.pathname,
    timeout = _ref.timeout,
    _ref$numRetries = _ref.numRetries,
    numRetries = _ref$numRetries === void 0 ? 1 : _ref$numRetries,
    customHost = _ref.customHost;
  try {
    var _extends2;
    var queryString = params ? "?" + new URLSearchParams(params).toString() : '';
    var host = customHost ? customHost : getExperimentsHost(environment);
    var url = "" + host + pathname + queryString;
    return Promise.resolve(fetchWithRetries({
      url: url,
      options: {
        headers: _extends({}, headers || {}, (_extends2 = {}, _extends2[ACCEPT] = 'application/json', _extends2)),
        timeout: timeout
      },
      numRetries: numRetries
    })).then(function (response) {
      if (!response.ok) {
        throw response.statusText;
      }
      return Promise.resolve(response.json());
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

// Do manual key check as JS usage could cause this not to be available
var getSapiHost = function getSapiHost(env) {
  if (!Object.keys(ENV_TO_HOST_MAP).includes(env)) {
    throw new Error("experiments-api-client getSapiHost Unsupported env passed: " + env);
  }
  var prefix = ENV_TO_HOST_MAP[env];
  return "https://studio-api" + prefix + ".shuttercorp.net";
};
var fetchStudioApi = function fetchStudioApi(_ref) {
  var environment = _ref.environment,
    headers = _ref.headers,
    params = _ref.params,
    pathname = _ref.pathname,
    timeout = _ref.timeout,
    _ref$numRetries = _ref.numRetries,
    numRetries = _ref$numRetries === void 0 ? 1 : _ref$numRetries;
  try {
    var _extends2;
    var queryString = params ? "?" + new URLSearchParams(params).toString() : '';
    var url = "" + getSapiHost(environment) + pathname + queryString;
    return Promise.resolve(fetchWithRetries({
      url: url,
      options: {
        headers: _extends({}, headers || {}, (_extends2 = {}, _extends2[ACCEPT] = 'application/json', _extends2)),
        timeout: timeout
      },
      numRetries: numRetries
    })).then(function (response) {
      if (!response.ok) {
        throw response.statusText;
      }
      return Promise.resolve(response.json());
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _excluded$2 = ["experimentId"];
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var SAPI_PATHNAME = '/user/experiments';
var EXPERIMENTS_SERVICE_ROOT_PATHNAME = "/experiments/";
var getEvaluationsFromExperimentsInterfaceArray = function getEvaluationsFromExperimentsInterfaceArray(experimentsArray) {
  return experimentsArray.reduce(function (acc, _ref) {
    var _extends2;
    var experimentId = _ref.experimentId,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    return _extends({}, acc, (_extends2 = {}, _extends2[experimentId] = rest, _extends2));
  }, {});
};
var getEvaluations = function getEvaluations(_ref2) {
  var environment = _ref2.environment,
    timeout = _ref2.timeout,
    user = _ref2.user,
    headers = _ref2.headers,
    numRetries = _ref2.numRetries,
    clientId = _ref2.clientId,
    _ref2$experimentsServ = _ref2.experimentsService,
    experimentsService = _ref2$experimentsServ === void 0 ? false : _ref2$experimentsServ,
    brand = _ref2.brand,
    customHost = _ref2.customHost;
  try {
    var _exit;
    var payload = {
      user: user
    };
    var _temp2 = _catch(function () {
      var _ref3, _extends3;
      if (!(user != null && user.anonymousId)) {
        throw new Error('Missing anonymousId');
      } else if (experimentsService) {
        if (!clientId) {
          throw new Error('Missing clientId');
        } else if (!brand) {
          throw new Error('Missing brand');
        }
      }
      var enrichedHeaders = _extends({}, user.authToken && (_ref3 = {}, _ref3[AUTHORIZATION] = user.authToken, _ref3), (_extends3 = {}, _extends3[X_END_USER_ANONYMOUS_ID] = user.anonymousId, _extends3[X_END_USER_COUNTRY] = user.country || '', _extends3[X_END_USER_LOCALE] = user.locale || '', _extends3), headers);
      var _temp = function () {
        if (!experimentsService) {
          return Promise.resolve(fetchStudioApi({
            environment: environment,
            headers: enrichedHeaders,
            pathname: SAPI_PATHNAME,
            timeout: timeout,
            numRetries: numRetries
          })).then(function (_ref4) {
            var _ref4$meta = _ref4.meta,
              _ref4$meta2 = _ref4$meta === void 0 ? {} : _ref4$meta,
              experiments = _ref4$meta2.experiments;
            payload.evaluations = experiments;
          });
        } else {
          enrichedHeaders[X_CLIENT_ID] = clientId;
          return Promise.resolve(fetchExperimentsService({
            environment: environment,
            headers: enrichedHeaders,
            pathname: "" + EXPERIMENTS_SERVICE_ROOT_PATHNAME + brand,
            timeout: timeout,
            numRetries: numRetries,
            customHost: customHost
          })).then(function (_ref5) {
            var experimentsArray = _ref5.experiments;
            var experiments = getEvaluationsFromExperimentsInterfaceArray(experimentsArray);
            payload.evaluations = experiments;
          });
        }
      }();
      if (_temp && _temp.then) return _temp.then(function () {});
    }, function (error) {
      payload.error = error;
    });
    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function (_result) {
      return _exit ? _result : payload;
    }) : _exit ? _temp2 : payload);
  } catch (e) {
    return Promise.reject(e);
  }
};

var _excluded$1 = ["req"];
// Gets experiment evaluations with overrides on variant values coming from query parameters or header settings
var getEvaluationsWithOverrides = function getEvaluationsWithOverrides(_ref) {
  var req = _ref.req,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  try {
    return Promise.resolve(getEvaluations(_extends({}, rest))).then(function (payload) {
      payload.evaluations = overrideEvaluations(req, payload.evaluations);
      return payload;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var _excluded = ["experimentId", "res", "query", "logger"];
/****
// This function will try and resolve an input experiment variant given the following priority
// 1. If experimentId being forced by a URL query
// 2. If experiments have already been fetched in response object
// 3. If not already present in response object, will fetch api experiments, use that value, & update the res.locals.experiments
// 4. If there is an error in the fetch, it will call logger, set res.locals.experiments to {}, & return 0
*****/
var getServerSideExperimentVariant = function getServerSideExperimentVariant(_ref) {
  var experimentId = _ref.experimentId,
    res = _ref.res,
    query = _ref.query,
    _ref$logger = _ref.logger,
    logger = _ref$logger === void 0 ? function (error) {
      return console.error("getServerSideExperimentVariant FAILED", error);
    } : _ref$logger,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  try {
    var _temp2 = function _temp2() {
      return getExperimentVariant(res.locals.experiments, experimentId);
    };
    var queryVariant = getQueryExperimentValue({
      query: query,
      experimentId: experimentId
    });
    if (queryVariant !== undefined) return Promise.resolve(queryVariant);
    var _temp = function (_res$locals) {
      if ((res == null || (_res$locals = res.locals) == null ? void 0 : _res$locals.experiments) === undefined) {
        return Promise.resolve(getEvaluationsWithOverrides(rest)).then(function (payload) {
          // If there was an error will resolve to setting empty experiments & returning 0
          if (payload.error !== undefined) {
            logger(payload.error);
            // If there are errors don't want developers missing it because their using Overrides
            payload.evaluations = {};
          }
          if (res.locals === undefined) {
            res.locals = {
              experiments: payload.evaluations
            };
          } else {
            res.locals.experiments = payload.evaluations;
          }
        });
      }
    }();
    return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
  } catch (e) {
    return Promise.reject(e);
  }
};

export { getEvaluations, getEvaluationsWithOverrides, getParamsFromURI, getServerSideExperimentVariant };
//# sourceMappingURL=index.js.map
